// ========================
// == Location search: on a geo page the search box shows that geo's name. Select it on
// == focus so typing replaces it instead of appending to "Lancaster County, PA".
/** @type {NodeListOf<HTMLInputElement>} */
const geoSearchInputs = document.querySelectorAll(".autocomplete_wrapper.has-clear .oi-autocomplete");

geoSearchInputs.forEach((input) => {
    /** @type {boolean} */
    let selectedOnFocus = false;

    input.addEventListener("focus", () => {
        input.select();
        selectedOnFocus = true;
    });
    // The click that focused the input would otherwise drop the selection on mouseup
    input.addEventListener("mouseup", (event) => {
        if (selectedOnFocus) {
            event.preventDefault();
        }
        selectedOnFocus = false;
    });
});
// END Location search
